import React, { PureComponent } from 'react';
import VizSensor from 'react-visibility-sensor';
import { TweenMax } from 'gsap';
import Button from '../../components/Button';
import { Determinator, withLang } from "react-multi-language";

class SectionSixNoLang extends PureComponent {
  mainAccountRefs = {
    clientIcon: null,
    title: null,
    description: null,
    button: null,
    topRight: null,
    topLeft: null,
    bottomLeft: null,
    bottomRight: null
  }

  componentDidUpdate() {
    if (this.props.activeSection === 8) {
      this.onInit();
    }
  }

  onInit = () => {
    TweenMax.to(
      this.mainAccountRefs.clientIcon,
      0.2,
      {
        filter: 'blur(0px)'
      }
    );
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.clientIcon,
        0.2,
        {
          transform: 'translate(50px, 0px) scale(1)'
        }
      );
    }, 400);

    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.topRight,
        1,
        {
          transform: 'translate(-15113px, 3046px)',
          ease: 'Elastic.easeOut'
        }
      );
    }, 100);
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.bottomLeft,
        1,
        {
          ease: 'Elastic.easeOut',
          transform: 'translate(-15476px, 3366px)'
          
        }
      );
    }, 250);
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.topLeft,
        1,
        {
          transform: 'translate(-15476px, 3046px)',
          ease: 'Elastic.easeOut'
        }
      );
    }, 500);
    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.bottomRight,
        1,
        {
          transform: 'translate(-15113px, 3366px)',
          ease: 'Elastic.easeOut'
        }
      );
    }, 350);

    setTimeout(() => {
      TweenMax.to(
        this.mainAccountRefs.title,
        .7,
        {
          transform: 'translateX(0px) translateY(0px) scale(1)',
          ease: 'Power4.easeOut',
          opacity: 1
        }
      );

      TweenMax.to(
        this.mainAccountRefs.description,
        .7,
        {
          transform: 'translateX(0px) translateY(0px) scale(1)',
          ease: 'Power4.easeOut',
          opacity: 1
        }
      );

      TweenMax.to(
        this.mainAccountRefs.button,
        .7,
        {
          transform: 'translateX(0px) translateY(0px) scale(1)',
          ease: 'Power4.easeOut',
          opacity: 1
        }
      );
    }, 450);
  }

  renderSvg = () => {
    return (
      <svg ref={ref => {this.mainAccountRefs.clientIcon = ref}} className="client-icon" width="500" height="500" viewBox="0 0 600 600">
        <g id="Group_2202"  transform="translate(-279 -5316)">
          <g id="Ellipse_346"  transform="translate(404 5441)" fill="none" stroke="#393939" strokeWidth="3" opacity="0.5">
            <circle cx="175" cy="175" r="175" stroke="none"/>
            <circle cx="175" cy="175" r="173.5" fill="none"/>
          </g>
          <g id="Group_2190"  transform="translate(126 52)">
            <path id="Subtraction_10"  d="M15807.7,2537.395a120.593,120.593,0,0,1-24.124-2.432,119.053,119.053,0,0,1-42.8-18.01,120.034,120.034,0,0,1-43.365-52.663,119.061,119.061,0,0,1-6.975-22.469,120.878,120.878,0,0,1,0-48.247,119.056,119.056,0,0,1,18.01-42.8,120.035,120.035,0,0,1,52.663-43.367,119.059,119.059,0,0,1,22.469-6.975,120.865,120.865,0,0,1,48.247,0,119.068,119.068,0,0,1,42.8,18.011,120.053,120.053,0,0,1,43.367,52.663,119.2,119.2,0,0,1,6.975,22.469,120.878,120.878,0,0,1,0,48.247,119.036,119.036,0,0,1-18.011,42.8,120.032,120.032,0,0,1-52.665,43.366,119.089,119.089,0,0,1-22.468,6.974A120.591,120.591,0,0,1,15807.7,2537.395Zm-53.047-138.145a18.252,18.252,0,1,0,0,36.5,18,18,0,0,0,8.821-2.223,16.625,16.625,0,0,0,6.328-6.076l-7.751-4.5a7.15,7.15,0,0,1-2.974,2.974,9.9,9.9,0,0,1-11.2-1.547,10.453,10.453,0,0,1,0-13.75,9.895,9.895,0,0,1,11.2-1.551,7.228,7.228,0,0,1,2.974,2.926l7.752-4.453a16.907,16.907,0,0,0-6.353-6.048A17.9,17.9,0,0,0,15754.652,2399.25Zm60.446,10.049a12.908,12.908,0,0,0-13.3,13.251,12.65,12.65,0,0,0,3.825,9.426,14.021,14.021,0,0,0,10.173,3.725c4.679,0,8.3-1.564,10.753-4.649l-6-4.2a6.4,6.4,0,0,1-4.549,1.751c-2.887,0-4.771-1.026-5.6-3.05h17.248a13.909,13.909,0,0,0-3.3-12.5A12.4,12.4,0,0,0,15815.1,2409.3Zm49.9,8.65v7.451c0,3.948,1.019,6.716,3.026,8.226,1.436,1.082,3.66,1.631,6.611,1.631a33.044,33.044,0,0,0,3.861-.256v-7.5c-.52.028-1,.042-1.425.042a8.652,8.652,0,0,1-2.573-.289,1.9,1.9,0,0,1-1.2-2.051v-7.251h5.2V2410h-5.2v-7l-8.3,2.5v4.5h-3.749v7.951Zm-19.8-.8a3.759,3.759,0,0,1,2.723,1,3.961,3.961,0,0,1,1.027,2.95V2435h8.3v-14.95c0-3.451-.866-6.135-2.574-7.979a8.68,8.68,0,0,0-6.623-2.774c-3.12,0-5.459,1.077-6.951,3.2V2410h-8.3v25h8.3v-13.3a4.832,4.832,0,0,1,1.075-3.374A3.907,3.907,0,0,1,15845.2,2417.149Zm-56.5-7.151v25h8.3v-25Zm-14.35-11.5V2435h8.3v-36.5Zm18.5-.1a4.66,4.66,0,0,0-3.374,1.4,4.54,4.54,0,0,0-1.427,3.35,4.8,4.8,0,0,0,9.6,0,4.54,4.54,0,0,0-1.427-3.35A4.66,4.66,0,0,0,15792.85,2398.4Zm27.05,21.4h-9.6a4.8,4.8,0,0,1,1.748-2.626,5.308,5.308,0,0,1,3.148-.875,4.956,4.956,0,0,1,3.027.875,4.813,4.813,0,0,1,1.674,2.625Z" transform="translate(-15354.001 3146)" fill="#393939"/>
            <g id="Group_2189"  transform="translate(0 0.001)">
              <path
                ref={ref => {this.mainAccountRefs.topRight = ref}}
                d="M15807.7,2417.7H15688V2298a120.582,120.582,0,0,1,24.124,2.432,119.044,119.044,0,0,1,42.8,18.011,120.056,120.056,0,0,1,43.366,52.664,119.067,119.067,0,0,1,6.975,22.469,120.609,120.609,0,0,1,2.432,24.122Zm-38.938-36.986a6.049,6.049,0,0,0-4.511,1.8,6.29,6.29,0,0,0,4.63,10.775,6.461,6.461,0,0,0,3.122-.742,5.725,5.725,0,0,0,2.158-2.015l-1.393-.817a3.857,3.857,0,0,1-1.5,1.476,4.734,4.734,0,0,1-2.364.563,4.948,4.948,0,0,1-3.226-1.067,4.346,4.346,0,0,1-1.552-2.892h10.537c.032-.318.048-.562.048-.746a6.591,6.591,0,0,0-1.643-4.451A5.47,5.47,0,0,0,15768.76,2380.711Zm-15.337,0a5.988,5.988,0,0,0-4.38,1.825,6.416,6.416,0,0,0,0,8.93,5.987,5.987,0,0,0,4.38,1.821,5.394,5.394,0,0,0,4.848-2.638V2393h1.587v-16.8h-1.587v7.153A5.389,5.389,0,0,0,15753.423,2380.711Zm-15.262,0a5.975,5.975,0,0,0-4.38,1.825,6.4,6.4,0,0,0,0,8.93,5.974,5.974,0,0,0,4.38,1.821,5.394,5.394,0,0,0,4.848-2.638V2393h1.583v-12h-1.583v2.353A5.389,5.389,0,0,0,15738.161,2380.711Zm39.073.29v12h1.583v-6.673a3.545,3.545,0,0,1,3.792-3.983v-1.539a3.913,3.913,0,0,0-3.792,2.186V2381Zm-51.364,0v12h1.587v-6.673a3.859,3.859,0,0,1,1.079-3.023,3.932,3.932,0,0,1,2.71-.96v-1.539a3.912,3.912,0,0,0-3.789,2.186V2381Zm-7.319-3.217V2393h1.683v-15.218h5.157V2376.2h-12v1.583Zm29.929-27.735h0V2365h1.683v-16.8h-1.44l-4.443,1.535.433,1.44,3.768-1.126Zm5.066,41.7a4.57,4.57,0,0,1-3.364-1.381,4.85,4.85,0,0,1,0-6.744,4.785,4.785,0,0,1,6.725,0,4.85,4.85,0,0,1,0,6.744A4.569,4.569,0,0,1,15753.546,2391.752Zm-15.266,0a4.566,4.566,0,0,1-3.36-1.381,4.837,4.837,0,0,1,0-6.744,4.78,4.78,0,0,1,6.721,0,4.84,4.84,0,0,1,0,6.744A4.569,4.569,0,0,1,15738.28,2391.752Zm34.8-5.495h-8.954a4.5,4.5,0,0,1,4.634-4.011,4.253,4.253,0,0,1,2.856,1.059,4.482,4.482,0,0,1,1.464,2.95Z"
                transform="translate(-15235 3146)"
                fill="#393939"
              />
              <path
                ref={ref => {this.mainAccountRefs.bottomRight = ref}}
                d="M15688,2417.7h0V2298h119.7a120.607,120.607,0,0,1-2.432,24.124,119.04,119.04,0,0,1-18.011,42.8,120.038,120.038,0,0,1-52.663,43.367,119.085,119.085,0,0,1-22.469,6.974A120.587,120.587,0,0,1,15688,2417.7Zm59.915-67.153a3.47,3.47,0,0,1,2.389.9,3.222,3.222,0,0,1,1,2.507c0,1.226-.872,2.719-2.591,4.439l-6.05,6.1V2366h10.68v-1.635h-8.28l4.8-4.772a15.484,15.484,0,0,0,2.3-2.833,5.355,5.355,0,0,0,.813-2.809,4.706,4.706,0,0,0-1.523-3.686,5.181,5.181,0,0,0-3.539-1.353,5.865,5.865,0,0,0-3.022.8,5.61,5.61,0,0,0-2.162,2.365l1.416.841A3.954,3.954,0,0,1,15747.916,2350.544Zm20.844-24.831a6.049,6.049,0,0,0-4.511,1.8,6.209,6.209,0,0,0-1.753,4.491,6.135,6.135,0,0,0,1.777,4.511,6.255,6.255,0,0,0,4.605,1.777,6.46,6.46,0,0,0,3.122-.746,5.7,5.7,0,0,0,2.158-2.015l-1.393-.817a3.855,3.855,0,0,1-1.5,1.476,4.732,4.732,0,0,1-2.364.563,4.93,4.93,0,0,1-3.226-1.067,4.329,4.329,0,0,1-1.552-2.892h10.537c.031-.3.048-.558.048-.742a6.6,6.6,0,0,0-1.643-4.455A5.468,5.468,0,0,0,15768.76,2325.714Zm-15.337,0a5.987,5.987,0,0,0-4.38,1.821,6.416,6.416,0,0,0,0,8.93,5.985,5.985,0,0,0,4.38,1.825,5.389,5.389,0,0,0,4.848-2.642V2338h1.587v-16.8h-1.587v7.153A5.386,5.386,0,0,0,15753.423,2325.714Zm-15.262,0a5.974,5.974,0,0,0-4.38,1.821,6.4,6.4,0,0,0,0,8.93,5.972,5.972,0,0,0,4.38,1.825,5.389,5.389,0,0,0,4.848-2.642V2338h1.583v-12h-1.583v2.353A5.386,5.386,0,0,0,15738.161,2325.714Zm39.073.286v12h1.583v-6.673a3.856,3.856,0,0,1,1.079-3.023,3.959,3.959,0,0,1,2.713-.96v-1.535a3.912,3.912,0,0,0-3.792,2.182V2326Zm-51.364,0v12h1.587v-6.673a3.858,3.858,0,0,1,1.079-3.023,3.944,3.944,0,0,1,2.71-.96v-1.535a3.911,3.911,0,0,0-3.789,2.182V2326Zm-7.319-3.214V2338h1.683v-15.214h5.157V2321.2h-12v1.587Zm35,13.965a4.586,4.586,0,0,1-3.364-1.376,4.85,4.85,0,0,1,0-6.744,4.785,4.785,0,0,1,6.725,0,4.85,4.85,0,0,1,0,6.744A4.583,4.583,0,0,1,15753.546,2336.75Zm-15.266,0a4.58,4.58,0,0,1-3.36-1.376,4.837,4.837,0,0,1,0-6.744,4.78,4.78,0,0,1,6.721,0,4.749,4.749,0,0,1-3.36,8.121Zm34.8-5.495h-8.954a4.491,4.491,0,0,1,4.634-4.007,4.265,4.265,0,0,1,2.856,1.055,4.485,4.485,0,0,1,1.464,2.95Z"
                transform="translate(-15235 3265)"
                fill="#393939"
              />
              <path
                ref={ref => {this.mainAccountRefs.bottomLeft = ref}}
                d="M15807.7,2417.7h-.017a120.5,120.5,0,0,1-24.106-2.431,119.047,119.047,0,0,1-42.8-18.01,120.062,120.062,0,0,1-43.368-52.663,119.225,119.225,0,0,1-6.975-22.469A120.631,120.631,0,0,1,15688,2298h119.7Zm-59.219-66.649h0V2366h1.683v-16.8h-1.44l-4.443,1.535.433,1.44,3.768-1.126Zm18.947-16.314h0l-1.344.793a4.129,4.129,0,0,0,1.694,1.992,5.415,5.415,0,0,0,2.939.77,4.9,4.9,0,0,0,3.13-.96,3.057,3.057,0,0,0,1.214-2.5,2.751,2.751,0,0,0-.722-1.979,4.068,4.068,0,0,0-1.749-1.079c-.714-.223-1.408-.421-2.063-.587a5.6,5.6,0,0,1-1.753-.746,1.484,1.484,0,0,1-.723-1.293,1.577,1.577,0,0,1,.746-1.4,3.155,3.155,0,0,1,1.777-.492,2.8,2.8,0,0,1,2.88,1.678l1.321-.765a4.063,4.063,0,0,0-1.635-1.79,4.915,4.915,0,0,0-2.566-.658,4.4,4.4,0,0,0-2.939.984,3.084,3.084,0,0,0-1.167,2.448,2.762,2.762,0,0,0,.723,1.979,4.042,4.042,0,0,0,1.749,1.079c.751.233,1.428.426,2.067.587a5.733,5.733,0,0,1,1.749.746,1.484,1.484,0,0,1,.723,1.293,1.572,1.572,0,0,1-.794,1.452,3.816,3.816,0,0,1-1.968.468,3.882,3.882,0,0,1-2.075-.54,2.809,2.809,0,0,1-1.214-1.476Zm-20.3-9.021a5.987,5.987,0,0,0-4.38,1.821,6.4,6.4,0,0,0,0,8.93,5.985,5.985,0,0,0,4.38,1.825,5.389,5.389,0,0,0,4.848-2.642V2338h1.583v-12h-1.583v2.353A5.386,5.386,0,0,0,15747.123,2325.714Zm31.416,1.821v7.272a3.023,3.023,0,0,0,1.262,2.833,4.324,4.324,0,0,0,2.214.492,10.505,10.505,0,0,0,1.567-.131v-1.393c-.625.026-1.162.038-1.6.038l-.325,0a1.527,1.527,0,0,1-1.154-.432,2.07,2.07,0,0,1-.385-1.4v-7.272h3.46V2326h-3.46v-3.36l-1.583.48V2326h-2.519v1.535Zm-60.385-6.336-6.455,16.8h1.777l1.56-4.129H15723l1.563,4.13h1.773l-6.455-16.8Zm43.707,4.8v12h1.583v-12Zm-4.943-5.519V2338h1.583v-17.519Zm-23.185,6.768a3.182,3.182,0,0,1,2.408.889,3.461,3.461,0,0,1,.853,2.5V2338h1.587v-7.367a5.03,5.03,0,0,0-1.261-3.59,4.549,4.549,0,0,0-3.444-1.329,4.445,4.445,0,0,0-4.03,2.158V2326h-1.587v12h1.587v-6.288a4.651,4.651,0,0,1,1.079-3.372A3.79,3.79,0,0,1,15733.733,2327.249Zm28.917-6.1a1.151,1.151,0,1,0,.817.337A1.1,1.1,0,0,0,15762.65,2321.151Zm-15.4,15.6a4.568,4.568,0,0,1-3.36-1.376,4.837,4.837,0,0,1,0-6.744,4.775,4.775,0,0,1,6.717,0,4.84,4.84,0,0,1,0,6.744A4.567,4.567,0,0,1,15747.246,2336.75Zm-24.843-4.463h-6.769l3.385-9,3.384,9Z"
                transform="translate(-15354 3266)"
                fill="#393939"
              />
              <path
                ref={ref => {this.mainAccountRefs.topLeft = ref}}
                d="M15807.7,2417.7H15688a120.6,120.6,0,0,1,2.432-24.123,119.021,119.021,0,0,1,18.012-42.8,120.05,120.05,0,0,1,52.664-43.368,119.1,119.1,0,0,1,22.468-6.975A120.558,120.558,0,0,1,15807.7,2298v119.7Zm-40.271-27.962h0l-1.344.794a4.133,4.133,0,0,0,1.694,1.991,5.416,5.416,0,0,0,2.939.766,4.882,4.882,0,0,0,3.13-.96,3.041,3.041,0,0,0,1.214-2.5,2.75,2.75,0,0,0-.722-1.979,4.015,4.015,0,0,0-1.749-1.079c-.65-.207-1.345-.4-2.063-.587a5.639,5.639,0,0,1-1.753-.746,1.5,1.5,0,0,1-.723-1.3,1.6,1.6,0,0,1,.746-1.4,3.182,3.182,0,0,1,1.777-.492,2.8,2.8,0,0,1,2.88,1.682l1.321-.77a4.075,4.075,0,0,0-1.635-1.785,4.909,4.909,0,0,0-2.566-.663,4.409,4.409,0,0,0-2.939.984,3.094,3.094,0,0,0-1.167,2.448,2.762,2.762,0,0,0,.723,1.98,4.1,4.1,0,0,0,1.749,1.083c.756.235,1.433.427,2.067.587a5.724,5.724,0,0,1,1.749.742,1.5,1.5,0,0,1,.723,1.3,1.579,1.579,0,0,1-.794,1.452,3.812,3.812,0,0,1-1.968.468,3.884,3.884,0,0,1-2.075-.539,2.84,2.84,0,0,1-1.214-1.476Zm-20.3-9.025a5.988,5.988,0,0,0-4.38,1.825,6.4,6.4,0,0,0,0,8.93,5.987,5.987,0,0,0,4.38,1.821,5.394,5.394,0,0,0,4.848-2.638V2393h1.583v-12h-1.583v2.353A5.389,5.389,0,0,0,15747.123,2380.711Zm31.416,1.825v7.272a3.022,3.022,0,0,0,1.262,2.833,4.322,4.322,0,0,0,2.214.492,10.5,10.5,0,0,0,1.567-.131v-1.393c-.625.026-1.162.038-1.6.038l-.325,0a1.527,1.527,0,0,1-1.154-.432,2.085,2.085,0,0,1-.385-1.4v-7.272h3.46V2381h-3.46v-3.36l-1.583.48V2381h-2.519v1.535Zm-60.385-6.336-6.455,16.8h1.777l1.56-4.129H15723l1.563,4.13h1.773l-6.455-16.8Zm43.707,4.8v12h1.583v-12Zm-4.943-5.522V2393h1.583v-17.523Zm-23.185,6.768a3.194,3.194,0,0,1,2.408.889,3.427,3.427,0,0,1,.853,2.5V2393h1.587v-7.371a5.024,5.024,0,0,0-1.261-3.586,4.534,4.534,0,0,0-3.444-1.333,4.447,4.447,0,0,0-4.03,2.162V2381h-1.587v12h1.587v-6.288a4.638,4.638,0,0,1,1.079-3.372A3.781,3.781,0,0,1,15733.733,2382.246Zm28.917-6.094a1.153,1.153,0,0,0-.813,1.968,1.155,1.155,0,0,0,1.631,0,1.152,1.152,0,0,0-.817-1.968Zm-14.734-26.608a3.408,3.408,0,0,1,2.389.9,3.222,3.222,0,0,1,1,2.507c0,1.226-.872,2.72-2.591,4.439l-6.05,6.1V2365h10.68v-1.635h-8.28l4.8-4.772a15.484,15.484,0,0,0,2.3-2.833,5.355,5.355,0,0,0,.813-2.809,4.706,4.706,0,0,0-1.523-3.686,5.179,5.179,0,0,0-3.539-1.353,5.865,5.865,0,0,0-3.022.8,5.61,5.61,0,0,0-2.162,2.365l1.416.841A3.95,3.95,0,0,1,15747.916,2349.544Zm-.67,42.207a4.553,4.553,0,0,1-3.36-1.381,4.837,4.837,0,0,1,0-6.744,4.775,4.775,0,0,1,6.717,0,4.84,4.84,0,0,1,0,6.744A4.552,4.552,0,0,1,15747.246,2391.752Zm-24.843-4.463h-6.769l3.385-9,3.384,9Z"
                transform="translate(-15354 3146)"
                fill="#393939"
              />
            </g>
          </g>
          <g id="Ellipse_347"  transform="translate(279 5316)" fill="none" stroke="#393939" strokeWidth="3" strokeDasharray="3" opacity="0.1">
            <circle cx="300" cy="300" r="300" stroke="none"/>
            <circle cx="300" cy="300" r="298.5" fill="none"/>
          </g>
        </g>
      </svg>
    );
  }

  render() {
    const {
      title,
      subtitle,
      button
    } = this.props.langProps;

    return (
      <section
          className="p_main-page__one-main-account"
        >
          <img src={process.env.PUBLIC_URL + '/bt-one-account.svg'} className="bt"/>
          <div className="fcont align-center container">
            <div className="fbody">
              <div className="justify-end fbody fleft align-center">
                {this.renderSvg()}
              </div>
              <div className="fbody col fright space-evenly">
                <div className="p_main-page__one-main-account__title" ref={ref => {this.mainAccountRefs.title = ref}}>
                  {title}
                </div>
                <div className="p_main-page__one-main-account__description" ref={ref => {this.mainAccountRefs.description = ref}}>
                  {subtitle}
                </div>

                <a className="button-link" href="https://dash.billtrade.io">
                  <Button
                    // bodyStyle={{ background: '#393939', boxShadow: 'none' }}
                    // textStyle={{ color: '#ffffff' }}
                    refc={ref => {this.mainAccountRefs.button = ref}}
                  >
                    {button}
                  </Button>
                </a>
              </div>
            </div>
          </div>

      </section>
    )
  }
}


const SectionSix = withLang({
  en: {
    title: `One account many traders`,
    subtitle: `You no longer need to have many accounts
    in to copy several traders or trade
    yourself - trade, copy, diversify on a single account`,
    button: `Join BillTrade`
  },
  ru: {
    title: `Один аккаунт много трейдеров`,
    subtitle: `Вам больше не нужно иметь много аккаунтов для того что бы копировать нескольких трейдеров или торговать самостоятельно - торгуйте, копируйте, диверсифицируйте на едином аккаунте.`,
    button: `Присоединиться к BillTrade`
  }
})(SectionSixNoLang);

export default SectionSix;
